export interface FilterDataOption{
    name: string,
    value: string
  }

export enum FilterOrgValueOptions{
  EMPTY = "####"
}

export enum ProgressBarColor {
  LOW = '#EF4444',
  MEDIUM = '#F59E0B',
  HIGH = '#10B981',
}

export enum ScoreLevels {
  LOW = 60,
  MEDIUM = 85,
  HIGH = 100
}